import React from 'react';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';
import { truncatePerex } from '../utils/text';
import PostDateTime from '../components/PostDateTime';
import Fleuron from '../components/Fleuron';

const IndexPage = ({ data }) => (
  <div className="articles">
    {data.allPrismicArticle.edges.map(({ node: { uid, data } }) => (
      <div key={uid}>
        <h2 style={{ marginBottom: 0 }}>
          <Link to={uid}>{data.title.text}</Link>
        </h2>
        <PostDateTime datetime={data.datetime} />
        <p>
          {truncatePerex(data.body.text)}
          <br />
          <Link to={uid}>Pokračovat ve čtení</Link>
        </p>
      </div>
    ))}
    <Fleuron />
  </div>
);

IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default IndexPage;

export const query = graphql`
  query IndexQuery {
    allPrismicArticle(sort: { fields: [data___datetime], order: DESC }) {
      edges {
        node {
          uid
          data {
            title {
              text
            }
            datetime(formatString: "D. M. YYYY, HH:mm")
            body {
              text
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js